import * as React from "react"

import Seo from "../components/Seo"
import Hero from '../components/Hero'
import Sidebar from '../components/Sidebar'
import Widget from '../components/Widget'
import SignUpSection from '../components/SignUpSection'
import { graphql } from "gatsby"
import SidebarWidget from "../components/SidebarWidget"
import { StaticImage } from "gatsby-plugin-image"
import Accordion from "../components/Accordion"

const displayWidgets = (widgets) => (
  widgets.map( widget => (
    <Widget
      key={ widget.widget_link_url }
      headline={ widget.widget_title } 
      text={ widget.widget_content } 
      label={ widget.widget_link_label }  
      link={ widget.widget_link_url }  
    />
  ))
)

const replaceHeading = (article, heading) => {
  let newArticle = '';
  newArticle = article.replace('<h2>', `<h2 id="${heading.value}">`);
  return newArticle;
}

export default function requestOnlineRegistrationCode({ data }) {

  // = = = = = = = = 
  // Forestry Data
  const pageData = data?.pageData?.frontmatter;
  const headings = data?.pageData?.headings;
  let article = data?.pageData?.html;
  const showWidgets = data?.pageData?.frontmatter.would_you_like_to_show_widgets_bellow_the_main_article;
  const widgets = data?.pageData?.frontmatter.bellow_article_widgets;
  const hasFaqsSection = data.pageData.frontmatter.has_faqs_section;
  const faqsData = data.pageData.frontmatter.frequently_asked_questions;

  // = = = = = = = = 
  // Utils

  // Add Heading as an ID to each headline
  headings?.forEach( heading => {
    article = replaceHeading(article, heading);
  });

  return(
    <>
      <Seo title = { pageData?.page_title } />

      <Hero 
        headline = { pageData?.hero_headline }
        intro = { pageData?.hero_intro }
      >
        <StaticImage 
          className="hero__picture"
          src="../../static/media/about-hero.jpg" 
          alt="" 
          loading="eager"
        />
      </Hero>

      <div className="page-content">
        <div className="container">
          <div className="row">

            <div className="col-md-3">
              <Sidebar 
                links = { pageData?.sidebar_links }
              >
                  
                  <SidebarWidget 
                    headline="How to choose your voters"
                    linkLabel="Step-by-step guide"
                    link="/registration-guide"
                  >
                    <StaticImage 
                      className="sidebar__widget__image" 
                      src="../../static/media/sidebar-widget-2.jpg" 
                      alt=""
                    /> 
                  </SidebarWidget>

                  <SidebarWidget 
                    headline="Become a Voter"
                    linkLabel="Express your interest"
                    link="/voting"
                  >
                    <StaticImage 
                      className="sidebar__widget__image" 
                      src="../images/sidebar-widget.jpg" 
                      alt=""
                    />
                  </SidebarWidget>

              </Sidebar>
            </div>

            <div className="col-md-9">
              <article className="article--faqs" dangerouslySetInnerHTML={{__html: article }} />

              {
                hasFaqsSection ?

                  <section className="faqs-section">
                    {
                      faqsData.map( faq => <Accordion key={faq.question} question={ faq.question } answer={ faq.answer } />)
                    }
                  </section>

                  : ''
              }
              {
                showWidgets === true
                  ? displayWidgets(widgets)
                  :''
              }
              
            </div>

          </div>
        </div>
      </div>

      <SignUpSection />
    </>
  )
}

// = = = = = = = = 
// GraphQL
export const query = graphql`
  query questionsQuery {
    pageData: markdownRemark(frontmatter: {page_title: {eq: "Frequently asked questions"}}) {
      frontmatter {
        page_title
        hero_headline
        hero_intro
        sidebar_links {
          link_label
          link_url
        }
        would_you_like_to_show_widgets_bellow_the_main_article
        bellow_article_widgets {
          widget_title
          widget_content
          widget_link_label
          widget_link_url
        }
        has_faqs_section
        frequently_asked_questions {
          question
          answer
        }
      }
      headings(depth: h2) {
        value
      }
      html
    }
  }
`;